import { useMediaQuery } from "./useMediaQuery.js";

/**
 * Whether the user has requested reduced motion at the OS level.
 * Animated components (Framer Motion variants, R3F auto-rotation, etc.)
 * should check this and fall back to a static or near-instant state.
 */
export function usePrefersReducedMotion() {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}
